import React from "react";

const sectionContext = React.createContext(false);
export default sectionContext;
